
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { supabase } from '@/integrations/supabase/client';

export const SidebarUserSection = () => {
  const { user, isAuthenticated, isAdmin, isCreator, logout } = useAuth();
  const { t, language } = useLanguage();

  console.log("SidebarUserSection - User details:", {
    isAuthenticated,
    isAdmin,
    isCreator,
    email: user?.email,
    userData: user?.user_metadata,
    userId: user?.id
  });

  if (isAuthenticated && user) {
    (async () => {
      try {
        const { data: profile, error } = await supabase
          .from('profiles')
          .select('role')
          .eq('id', user.id)
          .single();
        
        if (error) {
          console.error("SidebarUserSection - Error fetching profile:", error);
        } else {
          console.log("SidebarUserSection - DB profile:", profile);
          
          if (profile && profile.role && profile.role.toLowerCase() === 'admin' && !isAdmin) {
            console.error("ROLE MISMATCH: User is admin in DB but not recognized as admin in app");
          }
        }
      } catch (e) {
        console.error("SidebarUserSection - Unexpected error:", e);
      }
    })();
  }

  if (!isAuthenticated) {
    return (
      <Button variant="gradient" size="sm" className="w-full" asChild>
        <Link to="/auth/login">{language === 'fr' ? 'Se connecter' : 'Login'}</Link>
      </Button>
    );
  }

  const dashboardLink = isAdmin ? "/admin" : "/creator/panel";
  const dashboardText = isAdmin ? t('sidebar.dashboard') : t('sidebar.dashboard');

  const displayName = user?.user_metadata?.full_name || user?.email?.split('@')[0] || 'User';
  const avatarInitials = displayName.substring(0, 2).toUpperCase() || 'U';
  
  const roleText = isAdmin ? "Admin" : "Creator";

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2 p-2 bg-background/50 rounded-md border border-border/40">
        <Avatar className="h-9 w-9 shrink-0">
          <AvatarImage src={user?.user_metadata?.avatar_url || ""} alt={displayName} />
          <AvatarFallback>{avatarInitials}</AvatarFallback>
        </Avatar>
        <div className="flex flex-col text-sm min-w-0">
          <span className="font-medium truncate">{displayName}</span>
          <span className="text-xs text-muted-foreground">
            {roleText}
          </span>
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-2">
        <Button variant="outline" size="sm" asChild>
          <Link to={dashboardLink}>{dashboardText}</Link>
        </Button>
        <Button variant="outline" size="sm" onClick={logout}>
          {language === 'fr' ? 'Déconnexion' : 'Logout'}
        </Button>
      </div>
    </div>
  );
};
